import { useQuery } from '@tanstack/react-query';

import { useAuth } from '~hooks/useAuth';
import { userProfileQueryOptions } from '~libs/msGraph/msGraphQuery';
import type { UserProfile } from '~libs/msGraph/msGraphService';

const DEFAULT_PROFILE: UserProfile = {
  photo: { dataUrl: null, notFound: true },
  details: { displayName: '', mail: '', jobTitle: '' },
};

/**
 * Fetches the authenticated user's full profile (photo + details)
 * from Microsoft Graph via TanStack Query.
 *
 * Data is cached for 1 hour and garbage collected after 24 hours.
 * Photo failures gracefully degrade to no photo.
 */
function useUserProfile(): UserProfile {
  const { instance: msal, account } = useAuth();
  const { data } = useQuery(userProfileQueryOptions(msal, account));

  return data ?? DEFAULT_PROFILE;
}

export { useUserProfile };
